import styled from "styled-components";

export const MainPage = styled.div`
    .main-page-container {
        margin-bottom: 25px !important;
        position: relative;
    }

    @media (max-width: 768px) {
        .euiPanel {
            padding: 16px 0;
        }
        .main-page-container {
            margin-bottom: 0 !important;
        }
        .euiPanel {
            padding: 0;
        }
    }
`;

export const StyledPageContent = styled.div``;

export const ContentWrapper = styled.div`
    max-width: 1700px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;

    .drawer {
        margin-top: 30px;
    }
    @media (min-width: 574px) {
        .drawer {
            margin: 16px;
            margin-right: 30px;
            padding-right: 20px;
            position: fixed;
            flex-direction: row;
            min-width: 240px;
            + div {
                padding-left: 260px;
                max-width: 100%;
            }
        }
    }
`;

export const FullscreenContentWrapper = styled.div`
    display: flex;
    flex-direction: column;

    .drawer {
        margin-top: 50px;
    }
    @media (min-width: 574px) {
        .drawer {
            margin: 16px;
            margin-right: 30px;
            padding-right: 30px;
            position: fixed;
            margin-top: 70px;
            flex-direction: row;
            min-width: 320px;
            + div {
                padding-left: 340px;
                max-width: 100%;
            }
        }
    }
`;
